import { Badge, IconButton, Stack, Tooltip } from '@mui/material';
import { keyframes, styled } from '@mui/material/styles';
import { useCallback, useState } from 'react';
import { Iconify } from 'src/components/iconify';
import { MOBILE_BREAKPOINT } from 'src/config-global';
import { useLocales } from 'src/locales';
import { useNavbarContext } from 'src/provider/NavbarContext';
import { useLivekitRTCState } from 'src/provider/VoiceChannel/livekit/useLivekitRTCState';

const ringPulse = keyframes`
0% {
  transform: scale(0.9);
  opacity: 0.5;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
    }
    100% {
      transform: scale(0.9);
      opacity: 0.5;
      }
      `;

const slideInLeft = keyframes`
      0% {
        transform: translateX(-20px);
        opacity: 0;
        }
        100% {
          transform: translateX(0);
          opacity: 1;
          }
          `;

const IconButtonStyled = styled(IconButton)(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.up(MOBILE_BREAKPOINT)]: {
    display: 'flex',
  },
  padding: 1,
}));

const ConnectedCallIcon = styled(Iconify)(({ theme }) => ({
  color: theme.palette.success.main,
  animation: `${ringPulse} 2s ease-out`,
  animationIterationCount: 'infinite',
  width: theme.spacing(1),
  height: theme.spacing(1),
}));

const SlideInStack = styled(Stack)(() => ({
  animation: `${slideInLeft} 0.3s ease-out`,
  justifyContent: 'center',
}));

export const HideSideBarIconButton = () => {
  const { hiddenNavBar, setHiddenNavBar } = useNavbarContext();
  const { activeVoiceChannel } = useLivekitRTCState();
  const { translate } = useLocales();
  const [isHovered, setIsHovered] = useState(false);

  const handleToggleNavbar = useCallback(() => {
    setHiddenNavBar(!hiddenNavBar);
    setIsHovered(false);
  }, [hiddenNavBar, setHiddenNavBar]);

  const isConnected = !!activeVoiceChannel?.channel?._id;

  if (!hiddenNavBar) {
    return null;
  }

  return (
    <SlideInStack
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Tooltip title={translate('header.nav.open_sidebar')} placement="bottom">
        <IconButtonStyled
          color="inherit"
          onClick={(e) => {
            handleToggleNavbar();
            e.stopPropagation();
          }}
        >
          {isHovered ? (
            <Iconify
              icon="tabler:chevrons-right"
              sx={{
                width: 24,
                height: 24,
              }}
            />
          ) : (
            <Badge
              badgeContent={
                isConnected && (
                  <ConnectedCallIcon icon="tabler:percentage-100" />
                )
              }
            >
              <Iconify
                icon="tabler:menu-2"
                sx={{
                  width: 24,
                  height: 24,
                }}
              />
            </Badge>
          )}
        </IconButtonStyled>
      </Tooltip>
    </SlideInStack>
  );
};
